/**
 * Recommendations widget -- Horizontal scroll carousel with game, article, challenge cards.
 */

import type { Widget, WidgetContext } from '../types';

interface Reco {
  type: 'game' | 'article' | 'challenge';
  title: string;
  subtitle: string;
  module: string;
  color: string;
  icon: string;
}

function getMockRecos(t: (k: string, p?: Record<string, string | number>) => string): Reco[] {
  return [
    { type: 'game', title: 'Math Quest', subtitle: t('widget_reco_strengthen_fractions'), module: 'games', color: '#3B82F6', icon: '<svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="6" width="20" height="12" rx="2"/></svg>' },
    { type: 'article', title: '10 Study Techniques', subtitle: t('widget_reco_trending'), module: 'blog', color: '#14B8A6', icon: '<svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>' },
    { type: 'challenge', title: t('widget_reco_weekly_challenge'), subtitle: t('widget_reco_join_now'), module: 'community', color: '#8B5CF6', icon: '<svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>' },
  ];
}

export const Recommendations: Widget = {
  id: 'recommendations',
  label: { en: 'Recommendations', fr: 'Recommandations', ar: 'التوصيات', es: 'Recomendaciones', de: 'Empfehlungen' },
  icon: '💡',
  defaultVisible: true,
  defaultOrder: 11,
  defaultSize: 'expanded',

  render(container: HTMLElement, _size: 'compact' | 'expanded', ctx: WidgetContext): void {
    const recos = getMockRecos(ctx.t);

    container.innerHTML = `
      <h2 class="text-sm font-semibold mb-3 uppercase tracking-wide" style="color:var(--text-secondary);">${ctx.t('home_recommendations')}</h2>
      <div class="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1" style="scrollbar-width:none;-ms-overflow-style:none;">
        ${recos.map((r) => `
          <button class="flex-shrink-0 rounded-2xl p-4 transition-transform active:scale-95" style="width:160px;background:linear-gradient(135deg, ${r.color}15, ${r.color}08);border:1px solid ${r.color}20;box-shadow:var(--shadow-sm);" data-module="${r.module}">
            <div class="w-10 h-10 rounded-xl flex items-center justify-center mb-2" style="background:${r.color}20;color:${r.color};">
              ${r.icon}
            </div>
            <p class="text-xs font-bold truncate" style="color:var(--text-primary);">${r.title}</p>
            <p class="text-xs" style="color:var(--text-secondary);">${r.subtitle}</p>
          </button>
        `).join('')}
      </div>`;

    container.querySelectorAll<HTMLElement>('[data-module]').forEach((el) => {
      el.addEventListener('click', () => {
        const mod = el.dataset.module;
        if (mod) ctx.navigate(mod);
      });
    });
  },
};
